import React from 'react';
import styled, { css } from 'styled-components';

const paddingMixin = ({ type }: { type: 'workspace' | 'form' }) => {
  if (type === 'workspace') {
    return css`
      padding: 2px 10px;
      margin-left: 20px;
    `;
  }

  if (type === 'form') {
    return css`
      padding: 4px 10px 0 10px;
      margin-left: 20px;
    `;
  }

  return css`
    padding: 2px 10px;
    margin: 0;
  `;
};

const StyledBetaTag = styled.div<{ type: 'workspace' | 'form' }>`
  border-radius: 3px;
  background-color: #1a237e;
  font-size: 12px;
  color: white;
  display: inline-block !important;
  font-weight: bold;
  line-height: 99%;
  text-align: center;
  ${paddingMixin}
`;

const BetaTag = ({ type }: { type?: 'workspace' | 'form' }) => {
  return <StyledBetaTag type={type}>BETA</StyledBetaTag>;
};
export default BetaTag;
